export const DATABASECONNECTION_SHOW_RESET = 'DATABASECONNECTION_SHOW_RESET'
export const DATABASECONNECTION_SHOW_SET_ERROR = 'DATABASECONNECTION_SHOW_SET_ERROR'
export const DATABASECONNECTION_SHOW_SET_RETRIEVED = 'DATABASECONNECTION_SHOW_SET_RETRIEVED'
export const DATABASECONNECTION_SHOW_TOGGLE_LOADING = 'DATABASECONNECTION_SHOW_TOGGLE_LOADING'
